import { SET_TASK_COMPLETED, SET_ONBOARDING_COMPLETED } from './actions';

interface OnboardingState {
  profileCompleted: boolean;
  classroomCreated: boolean;
  studentsAdded: boolean;
  assignmentsCreated: boolean;
  onboardingCompleted: boolean;
}

const initialState: OnboardingState = {
  profileCompleted: true,
  classroomCreated: true,
  studentsAdded: false,
  assignmentsCreated: false,
  onboardingCompleted: false,
};

export const onboardingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_TASK_COMPLETED:
      const newState = {
        ...state,
        [action.payload]: action.value !== undefined ? action.value : true,
      };
      
      if (
        newState.profileCompleted &&
        newState.classroomCreated &&
        newState.studentsAdded &&
        newState.assignmentsCreated
      ) {
        newState.onboardingCompleted = true;
      }
      
      return newState;

    case SET_ONBOARDING_COMPLETED:
      return {
        ...state,
        onboardingCompleted: true,
      };

    default:
      return state;
  }
};
